module.exports = __webpack_public_path__ + "img/barcode.6128e390.png";